export default __webpack_public_path__ + "static/media/apps.5a0f81cc.svg";